export enum CREDIT_STATUS_ENUM {
  VALID = 'valid',
  PROCESSING = 'processing',
  CANCELED = 'canceled',
  EXPIRED = 'expired'
}
